export default __webpack_public_path__ + "2b71aaaf251adca99c25b09eb59848b4.png";